import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { applyPromoCode } from "src/api/referrals/referrals";
import { ApplyPromoCodePayload, RESPONSSTAUTS } from "src/types/api";
import { QUERYKEYS } from "src/types/queryKeys";
import { t } from "src/utils/i18nText";

export const useApplyPromoCode = () => {
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState({
    code: "",
    globalError: [""],
  });
  const { mutateAsync, isPending, isError, data, isSuccess } = useMutation({
    mutationKey: [QUERYKEYS.APPLY_PROMO_CODE],
    mutationFn: (payload: ApplyPromoCodePayload) => applyPromoCode(payload),
    onSuccess: (data) => {
      if (data?.status === RESPONSSTAUTS.SUCCESS) {
        queryClient.invalidateQueries({
          queryKey: [QUERYKEYS.PROMO_CODE],
          refetchType: "active",
        });
        queryClient.invalidateQueries({
          queryKey: [QUERYKEYS.USER],
          refetchType: "active",
        });
      } else {
        const errorData = data?.response?.data;
        if (errorData?.non_field_errors?.length || errorData?.detail) {
          setErrorMessage((prev) => ({
            ...prev,
            globalError: errorData?.non_field_errors || [errorData.detail],
          }));
        } else {
          setErrorMessage((prev) => ({
            ...prev,
            code: errorData?.code,
          }));
        }
      }
    },
    onError: () => {
      const errorMsg = t("queries.common.error");
      setErrorMessage((prev) => ({
        ...prev,
        globalError: [errorMsg],
      }));
    },
  });

  return {
    isSuccess,
    data,
    isError,
    isPending,
    applyPromoCodeMutate: mutateAsync,
    errorMessage,
    setErrorMessage,
  };
};
